import React from 'react';
import { Button, Dialog, DialogContent, DialogActions } from '@material-ui/core';
import BookingItemTimeslotSettings from '../../pages/bookingitemedit/components/BookingItemTimeslotSettings';
import { useCallback } from 'react';

function BookingEditTimeModal({ showModal, MODAL_TYPE, values, setFieldValue, bookingCanModify }) {
    // shallow copy is enough here
    const [modalValues, setModalValues] = React.useState(values);
    const setModalFieldValue = useCallback((field, value) => {
        console.log(field);
        setModalValues(prev => ({ ...prev, [field]: value }));
    }, []);
    const onSave = useCallback(() => {
        // the changed values are a limited set
        ['activity_start', 'activity_end'].forEach(field => {
            const value = modalValues[field];
            if (value !== undefined) {
                setFieldValue(field, value);
            }
        });
        setFieldValue('startChangeMode', true);
        showModal(MODAL_TYPE.NONE);
    }, [modalValues, setFieldValue, showModal, MODAL_TYPE]);
    return (
        <Dialog
            aria-labelledby="calendar-event-info-modal"
            maxWidth="sm"
            open
            onClose={() => showModal(MODAL_TYPE.NONE)}
        >
            <DialogContent>
                <BookingItemTimeslotSettings
                    values={modalValues}
                    setFieldValue={setModalFieldValue}
                    bookingCanModify={bookingCanModify}
                    datepickerInline
                />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={onSave}>
                    Save
                </Button>
                <Button variant="text" onClick={() => showModal(MODAL_TYPE.NONE)}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default BookingEditTimeModal;
